import * as React from 'react'

import { ThemeProvider } from './styled-components'
import { createTheme } from './Theme'

import useBreakpoint from '@utils/useBreakpoints'

interface Props {
  children: React.ReactNode
  insets?: { bottom: number; top: number }
}

const Provider = ({ children, insets = { bottom: 0, top: 0 } }: Props) => {
  const [, bp] = useBreakpoint()
  const Theme = React.useMemo(() => createTheme(bp, insets), [bp])

  return <ThemeProvider theme={Theme}>{children}</ThemeProvider>
}

export default Provider
